import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser, generalUnitPrice, intervalCount, optionalPositiveInt, optionalPositiveNumber, positiveInt, } from '#validation';
import { membersProductSchema, optionalString, overageStorageProductSchema, platformFeeProductSchema, storageProductSchema, teamCacheProductSchema, } from './common-billing.dto';
import { multiMonthlySubscriptionAmendment } from './plan-amendment.dto';
const limitsSchema = z.object({
    maxMembers: optionalPositiveInt,
    maxFilespaces: optionalPositiveInt,
    maxStorageTb: optionalPositiveNumber,
    maxGuestLinks: optionalPositiveNumber,
    maxEmailsPerGuestLink: optionalPositiveNumber,
});
const instalmentsSchema = z.object({
    startDate: dateParser(),
    endDate: dateParser(),
    number: positiveInt,
});
const multiMonthlySubscriptionSchema = z.object({
    type: z.literal('multi-monthly'),
    intervalCount: intervalCount,
    instalments: z.array(instalmentsSchema),
    serviceAccounts: z.object({}).optional(),
    orgInvite: z.object({}).optional(),
    awsStorage: storageProductSchema,
    members: membersProductSchema,
    teamCache: teamCacheProductSchema.optional(),
    platformFee: platformFeeProductSchema.optional(),
    nativeLayout: storageProductSchema.optional(),
    legacyProviders: z
        .object({
        wasabiStorage: storageProductSchema,
        ibmStorage: storageProductSchema,
    })
        .optional(),
    customStorage: storageProductSchema.optional(),
    amendments: z.array(multiMonthlySubscriptionAmendment),
    externalSubscriptionUrl: z.string().optional(),
});
const monthlySubscriptionSchema = z.object({
    type: z.literal('monthly'),
    awsStorage: overageStorageProductSchema,
    members: z.object({
        prepaid: z.object({ price: generalUnitPrice }),
        overage: z.object({ price: generalUnitPrice }),
    }),
    serviceAccounts: z.object({}).optional(),
    orgInvite: z.object({}).optional(),
    nativeLayout: overageStorageProductSchema.optional(),
    legacyProviders: z
        .object({
        wasabiStorage: overageStorageProductSchema,
        ibmStorage: overageStorageProductSchema,
    })
        .optional(),
    customStorage: overageStorageProductSchema.optional(),
    externalSubscriptionUrl: z.string().optional(),
});
const enterprisePlanSchema = z.object({
    contractId: optionalString,
    contractStartDate: dateParser(),
    contractEndDate: dateParser().optional(),
    poNumber: z.string().optional(),
    daysUntilDue: z.number(),
    subscription: z.discriminatedUnion('type', [
        monthlySubscriptionSchema,
        multiMonthlySubscriptionSchema,
    ]),
    limits: limitsSchema,
});
export class EnterprisePlanDto extends createZodDto(enterprisePlanSchema) {
}
